import script from "./SlidingScrollableListingComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./SlidingScrollableListingComponent.vue?vue&type=script&setup=true&lang=js"

import "./SlidingScrollableListingComponent.vue?vue&type=style&index=0&id=3c730d3a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c730d3a"]])

export default __exports__